/* eslint-disable indent */
import styled from 'styled-components';
import '../../styles/_variables.scss';
import { UNATTEMPTED, INPROGRESS, ASSIGNED, PAST_DUE_DATE } from './utils';
import {
  inlineFlexbox,
  justifyContent,
  alignItems
} from '../../styles/helpers/flexbox';

import { isDefined } from '../../helpers/utils';

const Cell = styled.div((props) => {
  let statusColor = '';
  const {
    status,
    percentage,
    isSelected,
    isCollapsed,
    isAssigned,
    isCellSelected,
    hasResults,
    isFiltered,
    isInstructionHubBlocked,
    isInstructionHubReadOnly
  } = props;

  let hoverBackgroundColor = null;
  const { colours } = props.theme;
  const assignmentSelected = '#dae7d3';
  const unattemptedSelected = '#b2e4ff';
  switch (status) {
    case UNATTEMPTED: {
      statusColor = isSelected ? unattemptedSelected : '#fff';
      hoverBackgroundColor = '#e5e5e5';
      break;
    }

    case ASSIGNED:
    case PAST_DUE_DATE:
    case INPROGRESS: {
      statusColor = isSelected ? assignmentSelected : '#dae7d3';
      hoverBackgroundColor = '#c3cfbd';
      break;
    }
    default: {
      statusColor = '#fff';
      break;
    }
  }

  statusColor = isCellSelected ? '#b2e4ff' : statusColor;

  if (isDefined(percentage) && !isAssigned) {
    switch (true) {
      case percentage >= 0 && percentage <= 50: {
        statusColor = '#900012';
        break;
      }

      case percentage > 50 && percentage <= 85: {
        statusColor = '#2452BB';
        break;
      }

      case percentage > 85 && percentage <= 100: {
        statusColor = '#008902';
        break;
      }

      default:
        break;
    }
  }

  const getBackgroundColor = () => {
    if (isFiltered && !isDefined(percentage)) {
      return colours.grey[100];
    }
    if (isCollapsed) {
      if (isAssigned) {
        statusColor = '#dae7d3';
      } else if (!hasResults) {
        statusColor = '#fff';
      }
    }
    return statusColor;
  };

  if (isInstructionHubBlocked) {
    const { palette } = props.theme;
    const isResultOnly = isDefined(percentage) && !isAssigned;

    return `
    width: 54px;
    min-height: 33px;
    max-height: 33px;
    box-sizing: border-box;
    background-color: ${
      isResultOnly ? colours.custom[800] : palette.primary.light
    };
    border: 1px solid ${colours.custom[600]};
    cursor: ${isInstructionHubReadOnly ? 'not-allowed' : 'pointer'};
    &: hover {
      border-color: ${palette.secondary.main};
    }
  `;
  }

  return `
    width: 54px;
    min-height: 33px;
    max-height: 33px;
    box-sizing: border-box;
    background-color: ${getBackgroundColor()};
    opacity: ${isFiltered ? 0.2 : 1};
    border: ${
      isSelected || isCellSelected
        ? '2px solid #00A5FF'
        : `1px solid ${colours.grey[400]}`
    };
    cursor: pointer;
    &: hover {
    background-color: ${hoverBackgroundColor};
  }
  `;
});

const ConversationStatus = styled.div`
  ${inlineFlexbox()};
  ${justifyContent('center')};
  ${alignItems('center')};

  position: relative;
  width: 54px;
  height: 28px;

  div[class*='svgIconComponent--'] {
    padding-top: 6px;
    margin-left: -17px;
  }
`;

const Result = styled.div((props) => {
  const { percentage, hasResults, isAssigned, isFiltered } = props;

  return `
  color: ${
    (hasResults || isDefined(percentage)) && isAssigned ? 'black' : 'white'
  };
  opacity; ${isFiltered ? 0.2 : 1};
  font-size: 14px;
  padding-top: 3px;
  padding-right: 3px;
  `;
});

export { Cell, ConversationStatus, Result };



// WEBPACK FOOTER //
// ./components/status-cell/styled.js